let player = undefined;

let identity = undefined;

/**
 * 开始播放
 */
export const play = (url, id) => {
	if (player && !player.paused) {
		player.pause();
	}

	if (identity === id) {
		identity = undefined;
	} else {
		identity = id;

		player = new Audio(url);

		player.play();

		return player;
	}
};

/**
 * 停止播放
 */
export const stop = () => {
	if (player && !player.paused) {
		player.pause();
	}
};
